import { create } from 'zustand';

export enum ModalStatus {
	CANCELLED = 'CANCELLED',
	COMPLETE = 'COMPLETE',
	CONFIRMED = 'CONFIRMED',
	ERROR = 'ERROR',
	HIDDEN = 'HIDDEN',
	VERIFYING = 'VERIFYING',
}

export interface Store {
	modalStatus: ModalStatus;
	setModalStatus: (val: ModalStatus) => void;
	setNextModalStatus: (val: ModalStatus) => void;
}

const modalFlow = [
	ModalStatus.VERIFYING,
	ModalStatus.CONFIRMED,
	ModalStatus.COMPLETE,
];

export const useSubscribeStore = create<Store>(set => ({
	modalStatus: ModalStatus.HIDDEN,
	setModalStatus: val => {
		set(state => ({ ...state, modalStatus: val }));
	},
	setNextModalStatus: val => {
		set(state => {
			const prevIndex = modalFlow.indexOf(state.modalStatus);
			const nextIndex = modalFlow.indexOf(val);
			if (nextIndex <= prevIndex) return state;

			return { ...state, modalStatus: val };
		});
	},
}));
